<template>
    <div>
        <modal
            :is-open="isOpen"
            :is-loading="loading"
            :disabled="loading"
            title="Управление коллекциями"
            :hide-footer="true"
            @onCloseModal="closeModal"
        >
            Названия ваших коллекций будут отображаться в каталоге ритейлеров.
            Добавить изделие в коллекцию можно с помощью массовых действий или
            через форму редактирования изделия.

            <div
                v-for="collection in collections"
                :key="collection.CollectionID"
                class="cabinet-form-group app-modal__list d-flex align-items-center"
            >
                <div>
                    {{ collection.Name }}
                    <div class="product-form-visibility__descr pt-0 pl-0">
                        {{
                            getNameById(
                                brands,
                                'BrandName',
                                'BrandID',
                                collection.BrandID
                            )
                        }}
                    </div>
                </div>
                <button
                    type="button"
                    class="cabinet-btn-icon cabinet-btn-icon--transparent cabinet-btn-icon--small cabinet-btn-icon--edit ml-auto"
                    @click="onUpdateCollectionClick(collection.CollectionID)"
                ></button>
                <button
                    type="button"
                    class="cabinet-btn-icon cabinet-btn-icon--transparent cabinet-btn-icon--small cabinet-btn-icon--trash"
                    @click="onDeleteCollectionClick(collection.CollectionID)"
                ></button>
            </div>

            <button
                type="button"
                class="cabinet-btn cabinet-btn--add cabinet-btn--add-white mt-24"
                @click="onAddCollectionClick"
            >
                Добавить коллекцию
            </button>
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/Elements/Modal'
import getNameById from '@/mixins/getNameById'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'ManageCollection',
    components: { Modal },
    mixins: [getNameById],
    props: {
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false
        }
    },
    computed: {
        ...mapState('supplierBrand', ['brands']),
        ...mapState('supplierCollections', ['collections'])
    },
    methods: {
        closeModal() {
            this.$emit('closeModal')
        },
        onAddCollectionClick() {
            this.$emit('onAddCollectionClick', 'manageCollection')
        },
        onDeleteCollectionClick(id) {
            this.$emit('openDeleteCollection', id)
        },
        onUpdateCollectionClick(id) {
            this.$emit('openUpdateCollection', id)
        }
    }
}
</script>
